<template>
  <div>
    <ul class="flex flex-wrap mb-3" id="pills-tab" role="tablist">
      <li
        class="nav-item"
        role="presentation"
        v-for="(month, index) in months.data"
        :key="index"
      >
        <button
          type="button"
          class="px-4 py-2 font-semibold"
          :class="{
            'text-white bg-default-500 rounded-lg shadow':
              month.competency === currentCompetency,
          }"
          v-on:click="changeCompetency(month.competency)"
        >
          {{ month.full_month }}
        </button>
      </li>
    </ul>
    <div class="tab-content" id="pills-tabContent">
      <div
        class="tab-pane fade"
        v-for="(month, index) in months.data"
        :key="index"
        :class="{ 'show active': month.competency == currentCompetency }"
        :id="'pills-' + month.competency"
        role="tabpanel"
        :aria-labelledby="'pills-' + month.competency + '-tab'"
      >
        <list-daily
          :link="month.link"
          v-if="month.competency == currentCompetency"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ListDaily from "./listDailyAgenda.vue";
export default {
  name: "listAgenda",
  components: { ListDaily },
  props: ["months"],
  data() {
    return {
      currentMonth: new Date().getMonth() + 1,
      currentYear: new Date().getFullYear(),
      currentCompetency: null,
    };
  },
  created() {
    let data = this.months.data.find(
      (data) => data.competency == `${this.months.year}${this.currentMonth}`
    );

    if (this.months.year === this.currentYear) {
      this.currentCompetency =
        data === undefined
          ? this.months.data[this.months.data.length - 1].competency
          : data.competency;
    } else {
      this.currentCompetency = this.months.data[0].competency;
    }
  },
  methods: {
    changeCompetency(competency) {
      this.currentCompetency = competency;
    },
  },
};
</script>

<style scoped></style>
